import { createReducer, on } from '@ngrx/store';
import { AppContextState, initialAppContextState } from './app-context.state';
import * as AppContextActions from './app-context.actions';
import { logout } from '../user/user.actions';

export const appContextReducer = createReducer(
  initialAppContextState,

  on(
    AppContextActions.setSelectedCountry,
    (state, { selectedCountry }): AppContextState => {
      return {
        ...state,
        persistedAppContext: {
          ...state.persistedAppContext,
          selectedCountry: selectedCountry ?? null,
        },
      };
    }
  ),

  on(
    AppContextActions.setAllCountries,
    (state, { allCountries }): AppContextState => {
      return {
        ...state,
        allCountries,
      };
    }
  ),

  on(
    AppContextActions.setOriginalUser,
    (state, { originalUser }): AppContextState => {
      return {
        ...state,
        persistedAppContext: {
          ...state.persistedAppContext,
          originalUser,
        },
      };
    }
  ),

  on(
    AppContextActions.setOriginalRole,
    (state, { originalRole }): AppContextState => {
      return {
        ...state,
        persistedAppContext: {
          ...state.persistedAppContext,
          originalRole,
        },
      };
    }
  ),

  on(
    AppContextActions.setIsSuperAdmin,
    (state, { isSuperAdmin }): AppContextState => {
      return {
        ...state,
        persistedAppContext: {
          ...state.persistedAppContext,
          isSuperAdmin,
        },
      };
    }
  ),

  on(
    AppContextActions.setPersistedAppContext,
    (state, context): AppContextState => {
      return {
        ...state,
        persistedAppContext: {
          selectedCountry: context.selectedCountry ?? null,
          originalUser: context.originalUser ?? '',
          originalRole: context.originalRole ?? '',
          isSuperAdmin: context.isSuperAdmin ?? 'N',
        },
      };
    }
  ),

  on(
    AppContextActions.hydrateAppContext,
    (state, { context }): AppContextState => {
      return {
        ...state,
        persistedAppContext: {
          selectedCountry: context.selectedCountry ?? null,
          originalUser: context.originalUser ?? '',
          originalRole: context.originalRole ?? '',
          isSuperAdmin: context.isSuperAdmin ?? 'N',
        },
      };
    }
  ),

  on(AppContextActions.clearAppContext, () => ({
    ...initialAppContextState,
  })),

  on(logout, () => ({
    ...initialAppContextState,
  }))
);
